import { render, staticRenderFns } from "./unitManagement.vue?vue&type=template&id=665f4d0a&scoped=true&"
import script from "./unitManagement.vue?vue&type=script&lang=js&"
export * from "./unitManagement.vue?vue&type=script&lang=js&"
import style0 from "./unitManagement.vue?vue&type=style&index=0&id=665f4d0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665f4d0a",
  null
  
)

export default component.exports